<ngx-spinner type="ball-scale-multiple"></ngx-spinner>
<app-preloader></app-preloader>
<app-sidebar></app-sidebar>
<router-outlet></router-outlet>
<app-footer class="no-print"></app-footer>
<ngx-scrolltop></ngx-scrolltop>